import { Action } from 'redux';

export const GET_BUYER_RULES = 'buyer-rules/GET_BUYER_RULES';

export interface GetBuyerRulesAction extends Action<typeof GET_BUYER_RULES> {}

export const getBuyerRules = (): GetBuyerRulesAction => ({
  type: GET_BUYER_RULES,
});

export const PERSIST_BUYER_RULES = 'buyer-rules/PERSIST_BUYER_RULES';
export interface PersistBuyerRulesAction extends Action<typeof PERSIST_BUYER_RULES> {
  readonly payload: {
    readonly rules: ReadonlyArray<BuyerRule>;
  };
}

export const persistBuyerRules = (rules: ReadonlyArray<BuyerRule>): PersistBuyerRulesAction => ({
  payload: {
    rules,
  },
  type: PERSIST_BUYER_RULES,
});

export const GET_BUYER_RULE = 'buyer-rules/GET_BUYER_RULE';
export interface GetBuyerRuleAction extends Action<typeof GET_BUYER_RULE> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly id: number;
  };
}

export const getBuyerRule = (id: number, meta: ActionMetaData = {}): GetBuyerRuleAction => ({
  meta,
  payload: {
    id,
  },
  type: GET_BUYER_RULE,
});

export const PERSIST_BUYER_RULE = 'buyer-rules/PERSIST_BUYER_RULE';
export interface PersistBuyerRuleAction extends Action<typeof PERSIST_BUYER_RULE> {
  readonly payload: {
    readonly rule: BuyerRule;
  };
}
export const persistBuyerRule = (rule: BuyerRule): PersistBuyerRuleAction => ({
  payload: {
    rule,
  },
  type: PERSIST_BUYER_RULE,
});

export const CREATE_BUYER_RULE = 'buyer-rules/CREATE_BUYER_RULE';
export interface CreateBuyerRuleAction extends Action<typeof CREATE_BUYER_RULE> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly rule: BuyerRule;
  };
}
export const createBuyerRule = (rule: BuyerRule, meta: ActionMetaData = {}): CreateBuyerRuleAction => ({
  meta,
  payload: {
    rule,
  },
  type: CREATE_BUYER_RULE,
});

export const UPDATE_BUYER_RULE = 'buyer-rules/UPDATE_BUYER_RULE';
export interface UpdateBuyerRuleAction extends Action<typeof UPDATE_BUYER_RULE> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly rule: BuyerRule;
  };
}
export const updateBuyerRule = (rule: BuyerRule, meta: ActionMetaData = {}): UpdateBuyerRuleAction => ({
  meta,
  payload: {
    rule,
  },
  type: UPDATE_BUYER_RULE,
});

export const DELETE_BUYER_RULE = 'buyer-rules/DELETE_BUYER_RULE';
export interface DeleteBuyerRuleAction extends Action<typeof DELETE_BUYER_RULE> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly rule: BuyerRule;
  };
}
export const deleteBuyerRule = (rule: BuyerRule, meta: ActionMetaData = {}): DeleteBuyerRuleAction => ({
  meta,
  payload: {
    rule,
  },
  type: DELETE_BUYER_RULE,
});

//
// --- Driver Data Import Actions ---

export const GET_DRIVER_IMPORT_FILES = 'buyer-rules/GET_DRIVER_IMPORT_FILES';
export interface GetDriverImportFilesAction extends Action<typeof GET_DRIVER_IMPORT_FILES> {
  readonly meta: ActionMetaData;
}

export const getDriverImportFiles = (meta: ActionMetaData = {}): GetDriverImportFilesAction => ({
  meta,
  type: GET_DRIVER_IMPORT_FILES,
});

export const PERSIST_DRIVER_IMPORT_FILES = 'buyer-rules/PERSIST_DRIVER_IMPORT_FILES';
export interface PersistDriverImportFilesAction extends Action<typeof PERSIST_DRIVER_IMPORT_FILES> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly files: ReadonlyArray<ProcessedDataFile>;
  };
}

export const persistDriverImportFiles = (
  files: ReadonlyArray<ProcessedDataFile>,
  meta: ActionMetaData = {},
): PersistDriverImportFilesAction => ({
  meta,
  payload: {
    files,
  },
  type: PERSIST_DRIVER_IMPORT_FILES,
});

export const GET_DRIVER_DATA_MAPPINGS = 'buyer-rules/GET_DRIVER_DATA_MAPPINGS';
export interface GetDriverDataMappingsAction extends Action<typeof GET_DRIVER_DATA_MAPPINGS> {
  readonly meta: ActionMetaData;
}

export const getDriverDataMappings = (meta: ActionMetaData = {}): GetDriverDataMappingsAction => ({
  meta,
  type: GET_DRIVER_DATA_MAPPINGS,
});

export const PERSIST_DRIVER_DATA_MAPPINGS = 'buyer-rules/PERSIST_DRIVER_DATA_MAPPINGS';
export interface PersistDriverDataMappingsAction extends Action<typeof PERSIST_DRIVER_DATA_MAPPINGS> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly mappings: ReadonlyArray<MappedFile>;
  };
}

export const persistDriverDataMappings = (
  mappings: ReadonlyArray<MappedFile>,
  meta: ActionMetaData = {},
): PersistDriverDataMappingsAction => ({
  meta,
  payload: {
    mappings,
  },
  type: PERSIST_DRIVER_DATA_MAPPINGS,
});

export const GET_DRIVER_DATA_MAPPING = 'buyer-rules/GET_DRIVER_DATA_MAPPING';
export interface GetDriverDataMappingAction extends Action<typeof GET_DRIVER_DATA_MAPPING> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly id: number;
  };
}

export const getDriverDataMapping = (id: number, meta: ActionMetaData = {}): GetDriverDataMappingAction => ({
  meta,
  payload: {
    id,
  },
  type: GET_DRIVER_DATA_MAPPING,
});

export const PERSIST_DRIVER_DATA_MAPPING = 'buyer-rules/PERSIST_DRIVER_DATA_MAPPING';
export interface PersistDriverDataMappingAction extends Action<typeof PERSIST_DRIVER_DATA_MAPPING> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly mapping: MappedFile;
  };
}

export const persistDriverDataMapping = (
  mapping: MappedFile,
  meta: ActionMetaData = {},
): PersistDriverDataMappingAction => ({
  meta,
  payload: {
    mapping,
  },
  type: PERSIST_DRIVER_DATA_MAPPING,
});

export const DELETE_DRIVER_DATA_MAPPING = 'buyer-rules/DELETE_DRIVER_DATA_MAPPING';
export interface DeleteDriverDataMappingAction extends Action<typeof DELETE_DRIVER_DATA_MAPPING> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly mapping: MappedFile;
  };
}

export const deleteDriverDataMapping = (
  mapping: MappedFile,
  meta: ActionMetaData = {},
): DeleteDriverDataMappingAction => ({
  meta,
  payload: {
    mapping,
  },
  type: DELETE_DRIVER_DATA_MAPPING,
});

export const UPLOAD_DRIVER_DATA_MAPPING = 'buyer-rules/UPLOAD_DRIVER_DATA_MAPPING';
export interface UploadDriverDataMappingAction extends Action<typeof UPLOAD_DRIVER_DATA_MAPPING> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly mapping: MappedFile;
  };
}

export const uploadDriverDataMapping = (
  mapping: MappedFile,
  meta: ActionMetaData = {},
): UploadDriverDataMappingAction => ({
  meta,
  payload: {
    mapping,
  },
  type: UPLOAD_DRIVER_DATA_MAPPING,
});

export const REUPLOAD_DRIVER_DATA_MAPPING = 'buyer-rules/REUPLOAD_DRIVER_DATA_MAPPING';
export interface ReuploadDriverDataMappingAction extends Action<typeof REUPLOAD_DRIVER_DATA_MAPPING> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly mapping: MappedFile;
  };
}

export const reuploadDriverDataMapping = (
  mapping: MappedFile,
  meta: ActionMetaData = {},
): ReuploadDriverDataMappingAction => ({
  meta,
  payload: {
    mapping,
  },
  type: REUPLOAD_DRIVER_DATA_MAPPING,
});

export type BuyerAccessAction =
  | GetBuyerRulesAction
  | PersistBuyerRulesAction
  | GetBuyerRuleAction
  | PersistBuyerRuleAction
  | CreateBuyerRuleAction
  | UpdateBuyerRuleAction
  | DeleteBuyerRuleAction
  | GetDriverImportFilesAction
  | PersistDriverImportFilesAction
  | GetDriverDataMappingsAction
  | PersistDriverDataMappingsAction
  | GetDriverDataMappingAction
  | PersistDriverDataMappingAction
  | DeleteDriverDataMappingAction
  | UploadDriverDataMappingAction
  | ReuploadDriverDataMappingAction;
